import { motion } from "framer-motion";
import styles from "./css/Question.module.css";
import { pageVariants, pageTransition, btnHover, btnTap } from "../utils/animations";

const Question01 = ({ setHandleEvent, setAvance }) => {

	const handleEvent = (value) => {
		setAvance(2);
		setHandleEvent(prevState => ({ ...prevState, value01: value }));
	};

	return (
		<motion.div
			className={styles.containerQuestion}
			variants={pageVariants}
			initial="initial"
			animate="animate"
			exit="exit"
			transition={pageTransition}
		>
			<div className={styles.titleQuestion}>
				¿Se encuentra satisfecho con el trato que recibió en recepción?
			</div>
			<div className={styles.containerOptions}>
				<motion.div className={styles.controlButton} onClick={() => handleEvent(1)} whileHover={btnHover} whileTap={btnTap}>
					Sí
				</motion.div>
				<motion.div className={styles.controlButton} onClick={() => handleEvent(0)} whileHover={btnHover} whileTap={btnTap}>
					No
				</motion.div>
			</div>
		</motion.div>
	);
};

export default Question01;
